import React, { useState, useEffect } from "react";
import { Box, Card, CardContent, Typography, Grid, Paper, Divider } from "@mui/material";
import FitnessCenterIcon from "@mui/icons-material/FitnessCenter";
import EventIcon from "@mui/icons-material/Event";
import LocalFireDepartmentIcon from "@mui/icons-material/LocalFireDepartment";
import DirectionsRunIcon from "@mui/icons-material/DirectionsRun";
import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck";

const ExerciseDetails = ({ exercises }) => {
  console.log("exercises",exercises)
  const [selectedExercise, setSelectedExercise] = useState(null);

  // Set first exercise as default when exercises data updates
  useEffect(() => {
    if (exercises.length > 0) {
      setSelectedExercise(exercises[0]);
    }
  }, [exercises]);

  return (
    <Box container spacing={2}>
      {/* Exercise List (Flex Wrap Layout) */}
      <Grid item xs={12} md={4}>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 2,
            overflowX: "auto",
            p: 1,
          }}
        >
          {exercises.length > 0 ? (
            exercises.map((exercise, index) => (
              <Card
                key={index}
                onClick={() => setSelectedExercise(exercise)}
                sx={{
                  flex: "0 0 auto",
                  minWidth: "250px",
                  cursor: "pointer",
                  borderLeft:
                    selectedExercise?.exercise_id === exercise.exercise_id
                      ? "5px solid #05b6b3"
                      : "5px solid gray",
                  bgcolor:
                    selectedExercise?.exercise_id === exercise.exercise_id
                      ? "#e0f7fa"
                      : "white",
                  transition: "0.3s",
                }}
              >
                <CardContent>
                  <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                    {exercise.exercise_name}
                  </Typography>
                  <Typography sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <PlaylistAddCheckIcon color="primary" /> Status: {exercise.exercise_status}
                  </Typography>
                </CardContent>
              </Card>
            ))
          ) : (
            <Typography>No exercises found.</Typography>
          )}
        </Box>
      </Grid>

      {/* Selected Exercise Details */}
      {selectedExercise && (
        <Grid item xs={12}>
          <Paper sx={{ p: 3, mt: 2, bgcolor: "#f5f5f5", borderRadius: 2 }}>
            {/* Exercise GIF */}
            <Box sx={{ textAlign: "center", mb: 2 }}>
              <img
                src={selectedExercise.gif_url}
                alt="Exercise GIF"
                style={{ width: "100%", maxWidth: "400px", borderRadius: "8px" }}
              />
            </Box>

            {/* Exercise Name */}
            <Typography variant="h5" sx={{ fontWeight: "bold", mb: 2 }}>
              {selectedExercise.exercise_name}
            </Typography>

            <Divider sx={{ mb: 2 }} />

            {/* Details Section */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <Typography sx={{ fontWeight: "bold", mt: 2 }}>Instructions:</Typography>
              <ul style={{ marginLeft: "20px" }}>
                {JSON.parse(selectedExercise.instructions).map((step, i) => (
                  <li key={i} style={{ marginBottom: "5px",textAlign:"left" }}>{step}</li>
                ))}
              </ul>
              <Typography sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <FitnessCenterIcon color="secondary" /> <strong>Primary Muscles:</strong> {selectedExercise.primary_muscles}
              </Typography>
              <Typography sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <DirectionsRunIcon color="success" /> <strong>Secondary Muscles:</strong> {selectedExercise.secondary_muscles}
              </Typography>
              <Typography sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <FitnessCenterIcon color="error" /> <strong>Equipment:</strong> {selectedExercise.equipment}
              </Typography>

              {/* Instructions */}
             

              <Typography sx={{ display: "flex", alignItems: "center", gap: 1, mt: 2 }}>
                <LocalFireDepartmentIcon color="error" /> <strong>Calories Burn:</strong> {selectedExercise.calories}
              </Typography>

              <Typography sx={{ fontWeight: "bold", mt: 2 }}>Exercise Benefits:</Typography>
              <Typography>{selectedExercise.exercise_benefits}</Typography>
            </Box>
          </Paper>
        </Grid>
      )}
    </Box>
  );
};

export default ExerciseDetails;
